import type { Testimonial } from '../types/content';
export const stats = [['3', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['100%', 'Listo para usar']];
export const testimonials: Testimonial[] = [{
  name: 'Mariana B.',
  place: 'Buenos Aires',
  quote: 'Terminaba el día con los hombros tensos y sin ganas de hacer nada más. Tener movimientos suaves ya preparados me permite dedicarme unos minutos sin complicarme.'
}, {
  name: 'Eugenia C.',
  place: 'Córdoba',
  quote: 'Pensaba que necesitaba saber bailar, pero son movimientos sencillos y las ilustraciones me ayudan a seguirlos. Me gusta poder practicar a mi ritmo.'
}, {
  name: 'Lorena G.',
  place: 'Rosario',
  quote: 'Lo que más me gustó fue el programa de 21 días. Ya tengo una práctica organizada para cada jornada y no pierdo tiempo buscando qué hacer.'
}];
export const extendedTestimonials: Testimonial[] = [{
  name: 'Paula D.',
  place: 'Mendoza',
  quote: 'Cuando tengo muchas preocupaciones, me cuesta encontrar un momento para mí. Los protocolos me dan una práctica concreta para hacer sin tener que pensar qué ejercicio elegir.'
}, {
  name: 'Sofía R.',
  place: 'La Plata',
  quote: 'Me encantó encontrar ejercicios que puedo hacer sentada. No siempre tengo ganas de moverme demasiado, y estas secuencias son una alternativa muy práctica.'
}, {
  name: 'Natalia V.',
  place: 'Neuquén',
  quote: 'Vivo en un departamento pequeño y pensaba que necesitaba más espacio. Con las prácticas adaptadas puedo moverme sin cambiar los muebles de lugar.'
}, {
  name: 'Fernanda T.',
  place: 'Mar del Plata',
  quote: 'Después de trabajar me costaba encontrar una forma sencilla de desconectarme de las obligaciones. Ahora tengo una rutina de movimientos lentos para acompañar el cierre del día.'
}];
